export const AgencyTypes = [
  {
    name: 'Advertising',
    value: 'advertising',
  },
  {
    name: 'Architecture',
    value: 'architecture',
  },
  {
    name: 'Branding',
    value: 'branding',
  },
  {
    name: 'Communications',
    value: 'communications',
  },
  {
    name: 'Computer Software',
    value: 'computer_software',
  },
  {
    name: 'Consulting',
    value: 'consulting',
  },
  {
    name: 'Consumer Electronics',
    value: 'consumer_electronics',
  },
  {
    name: 'Consumer Goods',
    value: 'consumer_goods',
  },
  {
    name: 'Content',
    value: 'content',
  },
  {
    name: 'Content Marketing',
    value: 'content_marketing',
  },
  {
    name: 'Creative',
    value: 'creative',
  },
  {
    name: 'Design',
    value: 'design',
  },
  {
    name: 'Digital Advertising',
    value: 'digital_advertising',
  },
  {
    name: 'Digital Marketing',
    value: 'digital_marketing',
  },
  {
    name: 'Digital Product',
    value: 'digital_product',
  },
  {
    name: 'Digital Production',
    value: 'digital_production',
  },
  {
    name: 'Digital Strategies',
    value: 'digital_strategies',
  },
  {
    name: 'Digital Strategy',
    value: 'digital_strategy',
  },
  {
    name: 'Education Management',
    value: 'education_management',
  },
  {
    name: 'Entertainment',
    value: 'entertainment',
  },
  {
    name: 'Furniture',
    value: 'furniture',
  },
  {
    name: 'Graphic Design',
    value: 'graphic_design',
  },
  {
    name: 'Growth',
    value: 'growth',
  },
  {
    name: 'Growth Marketing',
    value: 'growth_marketing',
  },
  {
    name: 'Growth Strategy',
    value: 'growth_strategy',
  },
  {
    name: 'Hospitality',
    value: 'hospitality',
  },
  {
    name: 'Image Editing',
    value: 'image_editing',
  },
  {
    name: 'Influencer Marketing',
    value: 'influencer_marketing',
  },
  {
    name: 'Information Technology & Services',
    value: 'information_technology_services',
  },
  {
    name: 'Insurance',
    value: 'insurance',
  },
  {
    name: 'Internet',
    value: 'internet',
  },
  {
    name: 'Leisure',
    value: 'leisure',
  },
  {
    name: 'Management Consulting',
    value: 'management_consulting',
  },
  {
    name: 'Marketing',
    value: 'marketing',
  },
  {
    name: 'Media Production',
    value: 'media_production',
  },
  {
    name: 'Non-profit Organization Management',
    value: 'non_profit_organization_management',
  },
  {
    name: 'PR',
    value: 'pr',
  },
  {
    name: 'Photography',
    value: 'photography',
  },
  {
    name: 'Production',
    value: 'production',
  },
  {
    name: 'Public Relations & Communications',
    value: 'public_relations_communications',
  },
  {
    name: 'Publishing',
    value: 'publishing',
  },
  {
    name: 'Retail',
    value: 'retail',
  },
  {
    name: 'SEO',
    value: 'seo',
  },
  {
    name: 'Social Media Marketing',
    value: 'social_media_marketing',
  },
  {
    name: 'Staffing & Recruiting',
    value: 'staffing_recruiting',
  },
  {
    name: 'Strategy',
    value: 'strategy',
  },
  {
    name: 'Travel',
    value: 'travel',
  },
  {
    name: 'Web Design',
    value: 'web_design',
  },
];
